/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import {
    UiTableBody,
    UiTableCell,
    UiTableRow,
} from 'components/Ui/UiTable'
import CompanyActivityLogItem, {
    ActivityItem,
} from './CompanyActivityLogItem'

interface CompanyActivityLogListProps {
    activities: ActivityItem[]
    emptyLabel: string
}

const CompanyActivityLogList = (props: CompanyActivityLogListProps) => {
    return (
        <UiTableBody className="CompanyActivityLogList">
            {props.activities.length > 0 ? (
                props.activities.map((activity, index) => (
                    <CompanyActivityLogItem
                        key={`${activity.type}-${activity.id}-${index}`}
                        activity={activity}
                    />
                ))
            ) : (
                <UiTableRow>
                    <UiTableCell
                        colSpan={4}
                        align="center"
                        className="py-8 text-gray-500"
                    >
                        {props.emptyLabel}
                    </UiTableCell>
                </UiTableRow>
            )}
        </UiTableBody>
    )
}

export default CompanyActivityLogList
